export default {
      id: "ic-success-noti-usage",
      viewBox: "0 0 71 64",
      url: "/" + "images/icons.3.109.2.svg#ic-success-noti-usage",
      toString: function () {
        return this.url;
      }
    }